<template>
  <tab-content-layout title="HISTÓRICO DE ESTORNO">
    <b-row class="v-clean">
      <b-col>
        <b-row>
          <b-col>
            <div class="d-flex align-items-end">
              <v-autocomplete-default
                style="width: 100%"
                :items="stock_items"
                item-text="name"
                item-value="id"
                label="FILTRAR POR MEDICAMENTO/PRODUTO"
                placeholder="DIGITE PARA PESQUISAR..."
                v-model="stock_item_id"
                @search="handleSearch"
                @change="handleChange"
              />
              <v-btn
                v-if="stock_item_id"
                @click="handleCancelChange"
                class="btn-cancel mb-1 ml-2"
                ><i class="fas fa-times mr-2"></i>CANCELAR</v-btn
              >
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-text-field
              outlined
              dense
              label="DATA INICIAL"
              v-model="dtInit"
              @input="paginate"
              type="date"
            />
          </b-col>
          <b-col>
            <v-text-field
              outlined
              dense
              label="DATA FINAL"
              v-model="dtEnd"
              @input="paginate"
              type="date"
            />
          </b-col>
          <b-col>
            <v-select-default
              label="FILTRAR POR USUÁRIO"
              :items="users"
              v-model="user_id"
              @change="paginate"
            />
          </b-col>
          <b-col>
            <v-select-default
              label="FILTRAR POR RESIDENTE"
              :items="residents"
              v-model="resident_id"
              @change="paginate"
            />
          </b-col>
          <b-col>
            <v-select-default
              item-text="name"
              item-value="id"
              :items="groups"
              label="GRUPO"
              v-model="stock_group_id"
              @change="paginate"
            />
          </b-col>
        </b-row>
        <b-row v-if="items.length > 0">
          <b-col cols="12" class="text-right">
            <v-btn @click="handlePrint" small class="btn-modern btn-modern-save"
              ><i class="fas fa-print"></i> IMPRIMIR</v-btn
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div v-if="items.length == 0" class="col-12 v-clean p-5">
              <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
            </div>
            <v-data-table
              v-if="items.length > 0"
              :headers="headers"
              :items="items"
              dense
              :server-items-length="count"
              :options.sync="options"
              :footer-props="{
                'items-per-page-options': [25, 50, 100],
                'items-per-page-text': 'Mostrar',
              }"
              :loading="loading"
              loading-text="Carregando..."
              no-data-text="Nenhum resultado corresponde aos filtros"
              no-results-text="Nenhum resultado corresponde aos filtros"
              @update:options="paginate"
            >
              <template v-slot:[`item.entity`]="{ item }">
                <div v-if="item.entity" class="row">
                  <div
                    v-for="k in Object.keys(item.entity)"
                    :key="k"
                    class="col-md-6 pt-0 pb-0 border-bottom"
                    v-show="item.fields[k] != 'ENTRADA'"
                  >
                    <small>{{ item.fields[k] }}:</small>
                    <small
                      ><strong class="ml-2">{{ item.entity[k] }}</strong></small
                    >
                  </div>
                </div>
              </template>
              <template v-slot:[`item.user_id`]="{ item }">
                <small>{{
                  professionalClassCouncilValue(getUserById(item.user_id))
                }}</small>
              </template>
              <template v-slot:[`item.date_time`]="{ item }">
                <small>
                  {{ item.when ? formatDate(item.when) : item.date_time }}
                </small>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <delete-history
                  v-if="$route.query.delete"
                  :_id="item._id"
                  @success="paginate"
                />
              </template>
            </v-data-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <errors-messages :errors="errors" />
  </tab-content-layout>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";
import TabContentLayout from "../../Components/TabContentLayout.vue";
import VSelectDefault from "../../Components/VSelectDefault.vue";
import VAutocompleteDefault from "../../Components/VAutocompleteDefault.vue";
import DeleteHistory from "./delete";

import {
  formatDate,
  formatTime,
  professionalClassCouncilValue,
} from "../../../lib/format";

import api from "../../../services/api";

import moment from "moment";

export default {
  name: "Output",

  components: {
    TabContentLayout,
    ErrorsMessages,
    VSelectDefault,
    VAutocompleteDefault,
    DeleteHistory,
  },

  props: {
    stock_items: { type: Array },
  },

  data() {
    return {
      // filtros
      table: "stocked_item",

      users: [],
      residents: [],
      stock_groups: [],
      dtInit: moment().subtract(30, "days").format("YYYY-MM-DD"),
      dtEnd: moment().format("YYYY-MM-DD"),
      search: "",
      user_id: "",
      resident_id: "",
      stock_item_id: "",
      stock_group_id: "",

      headers: [
        { text: "Informações", value: "entity", sortable: false },
        { text: "Responsável", value: "user_id", sortable: false },
        { text: "Ocorrência", value: "date_time", sortable: false },
        // { text: "", value: "actions", sortable: false },
      ],
      items: [],
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ["date_time"],
        sortDesc: [true],
        multiSort: true,
        mustSort: false,
      },
      count: 0,

      errors: [],
      show: false,
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  computed: {
    groups() {
      return [{ id: "", name: "TODOS" }, ...this.stock_groups];
    },
  },

  methods: {
    formatDate,
    formatTime,
    professionalClassCouncilValue,

    handleSearch(value) {
      this.$emit("search", value);
    },

    handleChange() {
      this.paginate();
    },

    handleCancelChange() {
      this.stock_item_id = "";
      this.paginate();
    },

    async retrieve() {
      await this.getUsers();
      await this.getResidents();
      await this.getStockGroups();
      await this.paginate();
    },

    getUserById(id) {
      for (let user of this.users) {
        if (user.id == id) {
          return {
            id: user.professional_class_council_id,
            name: user.name,
            value: user.professional_class_council_value,
            cpf: user.cpf,
            office: user.office,
          };
        }
      }

      return {
        id: null,
        name: "DEMO",
        value: null,
        cpf: null,
        office: null,
      };
    },

    async getUsers() {
      try {
        this.loading = true;

        let response = await api.get("/rest-home/users");

        let { error, errors, users } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.users = [{ id: "", name: "TODOS" }, ...users];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      try {
        this.loading = true;

        let response = await api.get("/rest-home/active-residents");

        let { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = [
            { id: "", name: "TODOS" },
            { id: "rest_home", name: "EMPRESA" },
            ...residents,
          ];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getStockGroups() {
      try {
        const response = await api.get("/rest-home/stock/groups");
        const { error, errors, stock_groups } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.stock_groups = stock_groups;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async paginate() {
      try {
        this.loading = true;

        let {
          table,
          options,
          search,
          user_id,
          resident_id,
          stock_item_id,
          stock_group_id,
          dtInit,
          dtEnd,
        } = this;

        let params = {
          table,
          user_id,
          resident_id,
          stock_item_id,
          stock_group_id,
          dtInit,
          dtEnd,
          search,
          page: options.page,
          items_per_page: options.itemsPerPage,
          action: "REVERSAL",
        };
        let response = await api.get("/rest-home/stock/history", { params });
        let { error, errors, items, count } = response.data;

        if (error) {
          this.items = [];
          this.count = 0;
          this.errors = errors;
        } else {
          this.errors = [];
          this.items = items;
          this.count = count;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handlePrint() {
      let {
        table,
        options,
        search,
        user_id,
        resident_id,
        stock_item_id,
        stock_group_id,
        dtInit,
        dtEnd,
      } = this;

      let query = {
        table,
        user_id,
        resident_id,
        stock_item_id,
        stock_group_id,
        dtInit,
        dtEnd,
        search,
        page: options.page,
        items_per_page: options.itemsPerPage,
        action: "REVERSAL",
        view: "reversal",
      };

      let route = this.$router.resolve({
        name: "stock-history-print",
        query,
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>

<style>
</style>